import { render, staticRenderFns } from "./enable.vue?vue&type=template&id=68961788&scoped=true&"
import script from "./enable.vue?vue&type=script&lang=ts&"
export * from "./enable.vue?vue&type=script&lang=ts&"
import style0 from "./enable.vue?vue&type=style&index=0&id=68961788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68961788",
  null
  
)

export default component.exports